import { translateFn } from '../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../ui/gzDataTable/types';
import { customHostnameValidators } from './utils/validators';

export enum ColumnKeys {
  NAME = 'name',
  IP = 'ip',
  CUSTOM_HOSTNAME = 'customHostname',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: DefaultColumnKeys.REORDER,
      header: '',
      columnType: IColumnType.DISPLAY,
    },
    {
      key: DefaultColumnKeys.PRIORITY,
      header: translateFn('Priority'),
      columnType: IColumnType.DISPLAY,
    },
    {
      key: ColumnKeys.NAME,
      header: translateFn('Security Server'),
      columnType: IColumnType.DISPLAY,
    },
    {
      key: ColumnKeys.IP,
      header: translateFn('IP'),
      columnType: IColumnType.DISPLAY,
    },
    {
      key: ColumnKeys.CUSTOM_HOSTNAME,
      header: translateFn('Custom server name/IP'),
      columnType: IColumnType.TEXT,
      validators: customHostnameValidators(),
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}
